import React from 'react';
import { useWatch } from 'react-hook-form';
import { StackedBar } from '../../../../../../../CommonComponents/OPL/charts/StackedBar/StackedBar';

export const AssetAllocationStackChart = () => {
  const chartValues = useWatch({
    name: 'accountPortfolio.assets',
  });

  if (!chartValues) {
    return null;
  }

  return (
    <StackedBar
      data={chartValues.map(item => ({
        label: item.name,
        color: item.color,
        value: Number(item.y),
        id: item.name,
      }))}
    />
  );
};
